import { useEffect } from 'react'

import Container from '@mui/material/Container';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import Lottie from 'lottie-react';

import { useAppDispatch } from '../../app/store/hooks';
import useTimeoutHandler from '../../hooks/useTimeoutHandler';
import { welcome, welcomeGreenTick } from '../../utils/lottieRefs/authLottieRefs';
import { setIsExistingUser } from './auth.slice';
import styles from "./WelcomeScreen.module.css"

const WelcomeScreen = () => {

  const dispatch = useAppDispatch()
  const [welcomeScreenTimeoutStart] = useTimeoutHandler(() => dispatch(setIsExistingUser(null)));

  useEffect(() => { welcomeScreenTimeoutStart(4500); }, [])

  return (
    <Dialog fullScreen open>
      <Container className={styles.welcome_screen_container}>
        <div className={styles.welcome_screen_animation_green_tick}>
          <Lottie animationData={welcomeGreenTick} loop={false} />
        </div>
        <div className={styles.welcome_screen_animation}>
          <Lottie animationData={welcome} loop={false} />
        </div>
        <div className={styles.welcomeTextContainer}><Typography className={styles.welcome_screen_text} variant="caption3Light">You&apos;re all set up! Be ready to unveil your inner chef</Typography></div>
      </Container>
    </Dialog>
  )
}

export default WelcomeScreen